<template>
  <a-tooltip
    v-if="text"
    overlay-class-name="td-tooltip followup-tooltip"
  >
    <template slot="title">
      <h3 class="title">
        {{ $t('message["441"]') }}
      </h3>
      <p v-if="!followup_lists || !followup_lists.length">
        {{ $t('message["1543"]') }}
      </p>
      <ul v-else>
        <li
          v-for="(item, index) in followup_lists"
          :key="item.id"
        >
          <div class="top clearfix">
            <span>{{ followup_lists.length - index }}. </span>
            <span class="name">{{ item.truename }}</span>
            <span class="time">{{ item.addtime }}</span>
          </div>
          <div class="content">
            {{ item.content }}
          </div>
        </li>
      </ul>
    </template>
    {{ text.last_followup_time || '- -' }}
  </a-tooltip>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    text: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    followup_lists () {
      return this.text.followup_lists
    }
  },
  methods: {
    moment
  }
}
</script>
<style lang="scss">
.followup-tooltip {
  width: 240px;
  .ant-tooltip-inner {
    max-height: 300px;
    overflow: auto;
    padding: 16px;
  }
  .title {
    margin-bottom: 16px;
  }
  li {
    margin-bottom: 16px;
  }
  .name {
    margin-right: 4px;
  }
  .content {
    color: $gray3;
  }
}
</style>
